import React from 'react';

const topBar = () => {
  return (
    <div className='top-bar pt-1 pb-1 text-light'>
      <div className='container'>
        <div className='d-flex justify-content-between'>
          <div className='d-flex pt-2 pb-2'>
            <div className='d-flex align-item-center mr-3'>
              <i className='fas fa-phone-alt mr-2' />
              <small>+216 28 846 888</small>
            </div>
            <div className='d-flex align-item-center'>
              <i className='fas fa-envelope mr-2' />
              <small>info@tunis-consulting.com</small>
            </div>
          </div>
          <div className='d-flex pt-2 pb-2'>
            <div className='social-media d-flex align-item-center'>
              <a href='https://www.facebook.com/profile.php?id=100088803589683' className='text-light' target="_blank" rel="noreferrer">
                <i className='fab fa-facebook-f mr-4' />
              </a>
              <a href='https://www.instagram.com/tunis_consulting/' className='text-light' target="_blank" rel="noreferrer">
                <i className='fab fa-instagram mr-4' />
              </a>
              <a href='https://goo.gl/maps/5m14kUpCrmtq2hSd9' className='text-light' target="_blank" rel="noreferrer"> 
                <i className='fas fa-map-marker-alt mr-4' /> 
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default topBar;
